import React from 'react'

export const EDUCATION_JOYRIDE_LOCALE = {
  close: 'Okay, got it!',
  last: 'Okay, got it!',
}

export const EDUCATION_JOYRIDE_TARGET_WAIT_MS = 5000

export const EDUCATION_JOYRIDE_SPOTLIGHT_PADDING = 4

export const JOYRIDE_HEADING_STYLE = {
  margin: '12px 0 8px',
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.36,
}

const JOYRIDE_CTA_BUTTON_STYLE = {
  fontSize: 14,
  fontWeight: 700,
}

const JOYRIDE_BODY_STYLE = {
  margin: 0,
  fontSize: 14,
}

const JOYRIDE_BULLET_LIST_STYLE = {
  margin: 0,
  paddingLeft: 16,
  fontSize: 14,
  listStyleType: 'disc',
}

export const buildJoyrideBulletBody = (intro, bullets) => (
  <>
    {intro ? (
      <p style={{ ...JOYRIDE_BODY_STYLE, marginBottom: 8 }}>{intro}</p>
    ) : null}
    <ul style={JOYRIDE_BULLET_LIST_STYLE}>
      {bullets.map((item, index) => (
        <li key={index} style={{ marginBottom: 4 }}>
          {item}
        </li>
      ))}
    </ul>
  </>
)

const getSpotlightOverlayStyles = (overlayColor) => ({
  overlay: {
    backgroundColor: 'transparent',
    mixBlendMode: 'normal',
  },
  spotlight: {
    backgroundColor: 'transparent',
    boxShadow: `0 0 0 9999px ${overlayColor}, 0 0 15px rgba(0, 0, 0, 0.5)`,
  },
})

export const buildEducationJoyrideStep = ({
  target,
  previewImg,
  previewAlt,
  title,
  body,
  placement = 'bottom',
  floaterProps,
  titleId,
  descId,
}) => ({
  target,
  title: '',
  content: (
    <>
      {previewImg ? (
        <img
          src={previewImg}
          alt={previewAlt || title}
          style={{ width: '100%', display: 'block', borderRadius: 8 }}
        />
      ) : null}
      <p
        id={titleId}
        style={{
          ...JOYRIDE_HEADING_STYLE,
          ...(previewImg ? {} : { marginTop: 0 }),
        }}
      >
        {title}
      </p>
      <div id={descId} style={JOYRIDE_BODY_STYLE}>
        {body}
      </div>
    </>
  ),
  placement,
  floaterProps,
  disableBeacon: true,
  hideFooter: true,
})

export const buildModerateEducationJoyrideStep = ({
  target,
  title,
  body,
  placement = 'bottom',
  floaterProps,
  titleId,
  descId,
}) => ({
  target,
  title: '',
  content: (
    <>
      {title ? (
        <p id={titleId} style={{ ...JOYRIDE_HEADING_STYLE, marginTop: 0 }}>
          {title}
        </p>
      ) : null}
      <div id={descId} style={JOYRIDE_BODY_STYLE}>
        {body}
      </div>
    </>
  ),
  placement,
  floaterProps,
  disableBeacon: true,
  hideFooter: true,
})

const baseEducationJoyrideStyles = {
  options: { width: 360, zIndex: 1015 },
  tooltip: {
    padding: 0,
  },
  tooltipTitle: {
    display: 'none',
    fontSize: 14,
    fontWeight: 700,
  },
  tooltipContent: {
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'left',
    margin: 0,
    padding: 0,
  },
  tooltipFooter: {
    display: 'none',
  },
  buttonNext: JOYRIDE_CTA_BUTTON_STYLE,
  buttonClose: JOYRIDE_CTA_BUTTON_STYLE,
}

export const getEducationJoyrideStyles = (variant) => {
  if (variant === 'moderate') {
    return {
      ...baseEducationJoyrideStyles,
      overlay: {
        display: 'none',
      },
      spotlight: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
    }
  }

  return {
    ...baseEducationJoyrideStyles,
    ...getSpotlightOverlayStyles('rgba(0, 0, 0, 0.65)'),
  }
}
